
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/market/[itemId]",
      function () {
        return require("private-next-pages/market/[itemId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/market/[itemId]"])
      });
    }
  